import { Icon, IconProps } from "@chakra-ui/react";

export function DocumentIcon({ ...rest }: IconProps) {
  return (
    <Icon
      width="29px"
      height="29px"
      viewBox="0 0 29 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M22.3541 24.1667C22.3541 24.3269 22.2905 24.4806 22.1772 24.5939C22.0639 24.7072 21.9102 24.7708 21.75 24.7708H7.24996C7.08972 24.7708 6.93605 24.7072 6.82275 24.5939C6.70945 24.4806 6.64579 24.3269 6.64579 24.1667V20.5417H4.83329V24.1667C4.83329 24.8076 5.0879 25.4223 5.54112 25.8755C5.99433 26.3287 6.60902 26.5833 7.24996 26.5833H21.75C22.3909 26.5833 23.0056 26.3287 23.4588 25.8755C23.912 25.4223 24.1666 24.8076 24.1666 24.1667V11.8755C24.1665 11.2346 23.9118 10.62 23.4585 10.1669L16.4152 3.12474C16.3965 3.10737 16.3767 3.09123 16.356 3.07641C16.341 3.06487 16.3265 3.05278 16.3125 3.04016C16.2293 2.9617 16.1409 2.88903 16.0478 2.82266C16.0169 2.8027 15.9846 2.78493 15.9512 2.76949L15.8932 2.74049L15.8328 2.70545C15.7675 2.66799 15.701 2.62932 15.6322 2.60032C15.3915 2.50422 15.1369 2.4479 14.8782 2.43357C14.8543 2.43202 14.8305 2.42919 14.8069 2.42511C14.7741 2.42005 14.741 2.41722 14.7078 2.41666H7.24996C6.60902 2.41666 5.99433 2.67127 5.54112 3.12448C5.0879 3.57769 4.83329 4.19238 4.83329 4.83332V15.7083H6.64579V4.83332C6.64579 4.67309 6.70945 4.51942 6.82275 4.40611C6.93605 4.29281 7.08972 4.22916 7.24996 4.22916H14.5V9.66666C14.5 10.3076 14.7546 10.9223 15.2078 11.3755C15.661 11.8287 16.2757 12.0833 16.9166 12.0833H22.3541V24.1667ZM16.3125 5.5837L20.9984 10.2708H16.9166C16.7564 10.2708 16.6027 10.2072 16.4894 10.0939C16.3761 9.98056 16.3125 9.82689 16.3125 9.66666V5.5837ZM10.5729 13.8958C10.3325 13.8958 10.102 13.9913 9.93206 14.1613C9.76211 14.3312 9.66663 14.5617 9.66663 14.8021C9.66663 15.0424 9.76211 15.2729 9.93206 15.4429C10.102 15.6128 10.3325 15.7083 10.5729 15.7083H18.427C18.6674 15.7083 18.8979 15.6128 19.0679 15.4429C19.2378 15.2729 19.3333 15.0424 19.3333 14.8021C19.3333 14.5617 19.2378 14.3312 19.0679 14.1613C18.8979 13.9913 18.6674 13.8958 18.427 13.8958H10.5729ZM3.32288 17.2187C3.08252 17.2187 2.85202 17.3142 2.68206 17.4842C2.51211 17.6541 2.41663 17.8846 2.41663 18.125C2.41663 18.3653 2.51211 18.5958 2.68206 18.7658C2.85202 18.9358 3.08252 19.0312 3.32288 19.0312H11.177C11.4174 19.0312 11.6479 18.9358 11.8179 18.7658C11.9878 18.5958 12.0833 18.3653 12.0833 18.125C12.0833 17.8846 11.9878 17.6541 11.8179 17.4842C11.6479 17.3142 11.4174 17.2187 11.177 17.2187H3.32288ZM10.5729 20.5417C10.3325 20.5417 10.102 20.6371 9.93206 20.8071C9.76211 20.977 9.66663 21.2076 9.66663 21.4479C9.66663 21.6883 9.76211 21.9188 9.93206 22.0887C10.102 22.2587 10.3325 22.3542 10.5729 22.3542H18.427C18.6674 22.3542 18.8979 22.2587 19.0679 22.0887C19.2378 21.9188 19.3333 21.6883 19.3333 21.4479C19.3333 21.2076 19.2378 20.977 19.0679 20.8071C18.8979 20.6371 18.6674 20.5417 18.427 20.5417H10.5729Z"
        fill="currentColor"
      />
    </Icon>
  );
}

export function DocumentIcon2({ ...rest }: IconProps) {
  return (
    <Icon
      width="18px"
      height="22px"
      viewBox="0 0 18 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M11 1H3C2.46957 1 1.96086 1.21071 1.58579 1.58579C1.21071 1.96086 1 2.46957 1 3V19C1 19.5304 1.21071 20.0391 1.58579 20.4142C1.96086 20.7893 2.46957 21 3 21H15C15.5304 21 16.0391 20.7893 16.4142 20.4142C16.7893 20.0391 17 19.5304 17 19V7L11 1Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 1V7H17"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 12H5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13 16H5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7 8H6H5"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </Icon>
  );
}

export const DocumentIcon3 = ({ ...rest }: IconProps) => {
  return (
    <Icon
      width="16px"
      height="18px"
      viewBox="0 0 16 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8604 7.805L7.62538 13.4083C7.49621 13.6325 7.42037 13.8833 7.40537 14.1417C7.3837 14.495 7.33703 15.2692 7.2937 16.0017C7.25537 16.6317 7.57704 17.2292 8.1237 17.545C8.67037 17.8608 9.34869 17.84 9.87536 17.4925C10.4879 17.0875 11.1354 16.6608 11.4304 16.4658C11.6462 16.3233 11.8262 16.1325 11.9554 15.9083L15.1904 10.305C15.6504 9.5075 15.3779 8.48834 14.5804 8.02834L13.137 7.195C12.3395 6.735 11.3204 7.0075 10.8604 7.805ZM13.6654 4.98417V2.5C13.6654 1.11917 12.5462 0 11.1654 0H2.83203C2.1687 0 1.53286 0.263331 1.06453 0.732498C0.595363 1.20083 0.332031 1.83667 0.332031 2.5V14.1667C0.332031 15.5475 1.4512 16.6667 2.83203 16.6667H5.28203C5.74203 16.6667 6.11537 16.2933 6.11537 15.8333C6.11537 15.3733 5.74203 15 5.28203 15H2.83203C2.37203 15 1.9987 14.6267 1.9987 14.1667V2.5C1.9987 2.27917 2.0862 2.06667 2.24286 1.91083C2.3987 1.75417 2.6112 1.66667 2.83203 1.66667H11.1654C11.6254 1.66667 11.9987 2.04 11.9987 2.5V4.98417C11.9987 5.44417 12.372 5.8175 12.832 5.8175C13.292 5.8175 13.6654 5.44417 13.6654 4.98417ZM12.3037 8.63833L13.747 9.47166L10.512 15.075L8.95704 16.1017L9.06871 14.2417L12.3037 8.63833ZM4.4987 12.5H6.31119C6.77119 12.5 7.14452 12.1267 7.14452 11.6667C7.14452 11.2067 6.77119 10.8333 6.31119 10.8333H4.4987C4.0387 10.8333 3.66536 11.2067 3.66536 11.6667C3.66536 12.1267 4.0387 12.5 4.4987 12.5ZM4.4987 9.16667H8.1237C8.5837 9.16667 8.95704 8.79333 8.95704 8.33333C8.95704 7.87333 8.5837 7.5 8.1237 7.5H4.4987C4.0387 7.5 3.66536 7.87333 3.66536 8.33333C3.66536 8.79333 4.0387 9.16667 4.4987 9.16667ZM4.4987 5.83333H9.4987C9.9587 5.83333 10.332 5.46 10.332 5C10.332 4.54 9.9587 4.16667 9.4987 4.16667H4.4987C4.0387 4.16667 3.66536 4.54 3.66536 5C3.66536 5.46 4.0387 5.83333 4.4987 5.83333Z"
        fill="currentColor"
      />
    </Icon>
  );
};
